import React from 'react';
import cx from 'classnames';
import styles from './TeamSettings.module.scss';
import { Link } from 'react-router-dom';

function ServiceCard({ service, to, connector }) {
  return (
    <Link
      to={to}
      className={cx(styles['service-card'], styles['service-link'])}
    >
      <span className={styles['service-card-icon']}>
        <img src={service.logo} alt={service.name} />
      </span>
      <span className={styles['service-card-title']}>
        <span className={styles['service-card-connector-name']}>
          {connector?.name}
        </span>
        <span className={styles['service-card-service-name']}>
          {service.name}
        </span>
      </span>
      <span className={styles['service-card-description']}>
        {service.description}
      </span>
    </Link>
  );
}

export default ServiceCard;
